import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import SwitchTransition from "react-transition-group/SwitchTransition";
import CSSTransition from "react-transition-group/CSSTransition";
import { stripHTMLFromString } from "../../../../../utils";

const useStyles = makeStyles({
  imageContainer: {
    width: "100%",
    height: "100%",
    "& > img": {
      width: "100%",
      height: "100%",
    },
  },
  slideTextOnImageContainer: {
    position: "absolute",
    top: "25%",
    right: "5%",
    width: "30%",
    height: "50%",
    boxSizing: "border-box",
    padding: "20px",
    backgroundColor: "#ffffffbd",
    display: "flex",
    flexDirection: "column",
    "& h2": {
      flexGrow: 0,
    },
    "& p": {
      flexGrow: 1,
    },
  },
  navigation: {
    position: "absolute",
    bottom: "10px",
    width: "100%",
    left: 0,
    display: "flex",
    justifyContent: "center",
    "& > ul": {
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li": {
        display: "inline-block",
        margin: "0 5px",
        "& > button": {
          boxSizing: "border-box",
          border: "3px solid white",
          width: "20px",
          height: "20px",
          borderRadius: "10px",
          backgroundColor: "white",
          "&.activeButton": {
            backgroundColor: "black",
          },
        },
      },
    },
  },
  slideContainer: {
    position: "relative",
    paddingTop: "calc(437 / 800 * 100%)",
    "& .fade-enter": {
      opacity: 0,
    },
    "& .fade-enter-active": {
      opacity: 1,
    },
    "& .fade-exit": {
      opacity: 0,
    },
    "& .fade-exit-active, & .fade-enter-active": {
      transition: "opacity 500ms, transform 500ms",
    },
    "& .fade-exit-active": {
      opacity: 0,
    },
  },
  innerSlideContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  },
});

export default ({ data }) => {
  const [slideNum, setSlideNum] = useState(0);
  const [stopped, setStopped] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    const interval = setInterval(
      () => {
        if (stopped) {
          return;
        }
        setSlideNum((slideNum) => {
          let newSlideNum = slideNum + 1;
          if (newSlideNum > data.slides.length - 1) {
            newSlideNum = 0;
          }
          return newSlideNum;
        });
      },
      data.duration * 1000 || 5000,
    );
    return () => clearInterval(interval);
  }, [stopped]);

  // This shouldn't happen:
  if (data.slides.length == 0) {
    return null;
  }

  console.log("Rendering!");

  return (
    <Container>
      <div className={classes.slideContainer}>
        <SwitchTransition mode={"in-out"}>
          <CSSTransition key={slideNum} timeout={500} classNames={"fade"}>
            <Slide
              slide={data.slides[slideNum]}
              currentSlideNum={slideNum}
              numSlides={data.slides.length}
              setSlideNum={(num) => {
                setSlideNum(num);
                setStopped(true);
              }}
            />
          </CSSTransition>
        </SwitchTransition>
      </div>
    </Container>
  );
};

export const Slide = ({ slide, currentSlideNum, numSlides, setSlideNum }) => {
  const classes = useStyles();

  return (
    <div className={classes.innerSlideContainer}>
      <div className={classes.imageContainer}>
        <img src={slide.background} />
        <div className={classes.navigation}>
          <ul>
            {Array.from(Array(numSlides)).map((val, idx) => {
              return (
                <li key={idx}>
                  <button
                    className={idx == currentSlideNum ? "activeButton" : ""}
                    onClick={() => setSlideNum(idx)}
                  />
                </li>
              );
            })}
          </ul>
        </div>
        <SlideTextOnImage slide={slide} />
      </div>
    </div>
  );
};

const SlideTextOnImage = ({ slide }) => {
  const classes = useStyles();

  return (
    <div
      className={`${classes.slideTextOnImageContainer} slide-text-container`}
    >
      <h2>{stripHTMLFromString(slide.title)}</h2>
      <p>{stripHTMLFromString(slide.text)}</p>
      {slide.button.text && (
        <Button
          color="Primary"
          variant="contained"
          fullWidth
          href={slide.button.link}
        >
          {slide.button.text}
        </Button>
      )}
    </div>
  );
};
